import React, {useEffect, useState} from 'react';
import {Controller, useForm} from "react-hook-form";
import {enablePolicies, updatePolicy} from "utility/apis/SetupGuideService";
import {Button, Dialog, DialogActions, Grid, Select, TextField, CircularProgress} from "components/Mui";
import {fromYearsArr} from "utility/constants/data";
import {DISABLE_POLICY_MODAL} from "utility/modals/constants";
import withModals from "hoc/withModals/withModals";
import {getErrorMessage} from "utility/helpers/utils";
import {toast} from "react-toastify";

const UnPaidLeavePolicy = (props) => {
    const {unPaidPolicy, tenantId, setInProgress, refreshPolicyData, colorTheme, modals, toggleDisablePolicyModal} = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { register, control, reset, handleSubmit, errors } = useForm({
        defaultValues: {},
    });
    useEffect(() => {
        reset(unPaidPolicy);
    }, [unPaidPolicy]);
    const handleSave = async (data) => {
        setInProgress(true);
        try {
            await updatePolicy("unPaidPolicy", unPaidPolicy?.id, tenantId, data);
            refreshPolicyData();
            toast.success("Updated Successfully");
        } catch (e) {
            toast.error(getErrorMessage(e));
            setInProgress(false);
        }
    };
    const handleDisable = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        const payload = [{
            policyType: unPaidPolicy?.type,
            enable: false
        }];
        try {
            await enablePolicies(tenantId, payload);
            refreshPolicyData();
            toast.success("Disabled Successfully");
            toggleDisablePolicyModal();
        } catch (e) {
            toast.error(getErrorMessage(e));
            setIsSubmitting(false);
        }
    };
    return (
        <div id="UnPaidLeavePolicy" className="c-un-paid-leave-policy px-4 mt-3">
            <form id="UnPaidLeavePolicy" onSubmit={handleSubmit(handleSave)}>
                <Grid container spacing={{md: 1, xs: 0}}>
                    <Grid item xs={4}>
                        <Controller
                            as={
                                <TextField
                                    errors={errors}
                                    label="Minimum Service Time"
                                    type="number"
                                    inputRef={register({
                                        required: "This field is required",
                                        validate: (value) =>
                                            value >= 0,
                                    })}
                                    inputProps={{
                                        min: 0,
                                        step: "any"
                                    }}
                                />
                            }
                            id="effectiveFrom"
                            control={control}
                            mode="onBlur"
                            name="effectiveFrom"
                            defaultValue={unPaidPolicy.effectiveFrom}
                        />
                    </Grid>
                    <Grid item md={3} xs={4}>
                        <Controller
                            as={
                                <Select options={fromYearsArr} />
                            }
                            id="effectiveFromUnit"
                            control={control}
                            mode="onBlur"
                            name='effectiveFromUnit'
                            defaultValue={unPaidPolicy.effectiveFromUnit}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" className='float-end my-3'>
                            Save
                        </Button>
                        <Button className="bg-danger float-end my-3 mx-3" color="secondary" variant="outlined"
                                onClick={toggleDisablePolicyModal}>
                            Disable Policy
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <Dialog
                className="details-dialog"
                open={modals[DISABLE_POLICY_MODAL]}
                toggle={toggleDisablePolicyModal}
            >
                <div>
                    <div className="m-4" style={{color: colorTheme}}>
                        Are you sure you want to disable ( UnPaid Leaves ) Policy?
                    </div>
                    <div>
                        <DialogActions className="p-3 mt-3">
                            <Button
                                className="px-4 me-3"
                                variant="outlined"
                                onClick={toggleDisablePolicyModal}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="px-4 bg-danger"
                                color="secondary"
                                variant="outlined"
                                onClick={handleDisable}
                            >
                                {isSubmitting ? (
                                        <CircularProgress size={24} color="inherit" />
                                    ) :
                                    "Disable"
                                }
                            </Button>
                        </DialogActions>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
const modalsProps = {
    toggleDisablePolicyModal: DISABLE_POLICY_MODAL,
};

export default withModals(UnPaidLeavePolicy, modalsProps);
